






import { defineComponent } from '@nuxtjs/composition-api';
import { BaseHeading } from '@shared/ui';

export default defineComponent({
  name: 'PageTitle',
  components: {
    BaseHeading,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    headingLevel: {
      type: Number,
      default: 1,
    },
  },
});
